import React, { Component } from "react";
import Row from "../../containers/row";
import Majors from "./majors";
import Minors from "./minors";
import Graduate from "./graduate";
import CollegesAndSchools from "./collegesAndSchools";
import AccelleratedMasters from "./accelleratedMasters";
import MMStyles from "./styles/mmStyles";
import Loader from "../../loader";
import ErrorComponent from "../../errorComponent";
// import { goToAnchor, configureAnchors } from "react-scrollable-anchor";
import "./majorsMinors.css";

// configureAnchors({ offset: 300, scrollDuration: 200 });

class MajorsMinors extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      error: false,
      value: -1,
      majors: [],
      open: {},
      styles: {
        majors: MMStyles.hidden,
        minors: MMStyles.hidden,
        graduate: MMStyles.hidden,
        atm: MMStyles.hidden,
        colleges: MMStyles.hidden
      }
    };
  }

  handleErrors(response) {
    // Check for !200 response
    if (!response.ok) {
      throw Error(response.status);
    }
    return response;
  }

  /* */
  componentDidMount() {
    let host = "";
    switch (window.location.hostname) {
      case "react.drup2-dev.uvm.edu":
      case "localhost":
        host = 'https://content.drup2-dev.uvm.edu';
        break;
      case 'react.drup2-staging.uvm.edu':
        host = 'https://content.drup2-staging.uvm.edu';
        break;
      default:
          host = 'https://www.uvm.edu/content';
    }
    const url = host + "/shared/json/node?filter[type]=program&range=200&sort=title&filter[field_areas_study]=" + this.props.row.field_row_content[0].field_area_study;
    fetch(url)
      .then(this.handleErrors)
      .then(response => response.json())
      .then(data =>
        this.setState(
          {
            majors: data.data,
            loading: false
          },
          () => this.getHash()
        )
      )
      .catch(error => this.setState({ loading: false, error }));
  }

  /* */
  getHash() {
    let value = 0;

    switch (window.location.hash) {
      case "#majors":
        value = 0;
        break;
      case "#minors":
        value = 1;
        break;
      case "#graduate":
        value = 2;
        break;
      case "#accelleratedmasters":
        value = 3;
        break;
      case "#collegesandschools":
        value = 4;
        break;
      default:
        value = 5;
    }
    this.setState({ value });
  }

  handleChange = event => {
    this.setState({ value: Number(event.target.value) });
    // goToAnchor("ATZ", false);
  };

  renderView() {
    switch (this.state.value) {
      case 0:
        window.location.hash = "majors";
        // goToAnchor("mmgac", false);
        return <Majors data={this.state.majors} row={this.props} />;
      case 1:
        window.location.hash = "minors";
        // goToAnchor("mmgac", false);

        return <Minors data={this.state.majors} row={this.props} />;
      case 2:
        window.location.hash = "graduate";
        // goToAnchor("mmgac", false);

        return <Graduate data={this.state.majors} row={this.props} />;
      case 3:
        window.location.hash = "accelleratedmasters";

        // goToAnchor("mmgac", false);
        return (
          <AccelleratedMasters data={this.state.majors} row={this.props} />
        );
      case 4:
        window.location.hash = "collegesandschools";
        // goToAnchor("mmgac", false);
        return <CollegesAndSchools data={this.state.majors} row={this.props} />;
      default:
        return <Majors data={this.state.majors} row={this.props} />;
    }
  }
  handleOpen = event => {
    const open = this.state.open;
    switch (event.target.id) {
      case "majors":
        open.majors = !open.majors;
        document.getElementById("m0").focus();
        break;
      case "minors":
        open.minors = !open.minors;
        document.getElementById("m0").focus();
        break;
      case "graduate":
        open.graduate = !open.graduate;
        document.getElementById("g0").focus();
        break;
      case "atm":
        open.atm = !open.atm;
        document.getElementById("a0").focus();
        break;
      case "colleges":
        open.colleges = !open.colleges;
        break;
      default:
        break;
    }
    const styles = {
      majors: MMStyles.hidden,
      minors: MMStyles.hidden,
      graduate: MMStyles.hidden,
      atm: MMStyles.hidden,
      colleges: MMStyles.hidden
    };
    for (const k in open) {
      if (open[k] === true) {
        styles[k] = MMStyles.visible;
      }
      this.setState({
        open: open,
        styles: styles
      });
    }
  };

  render() {
    if (window.innerWidth > 899) {
      const { loading, error } = this.state;
      return loading ? (
        <Loader />
      ) : error ? (
        <ErrorComponent error={error} />
      ) : (
        <div id="mmgac" style={{ backgroundColor: "#EAF5FB" }}>
          <div
            position="static"
            color="default"
            className={"appbar"}
            style={MMStyles.container}
          >
            <button
              id="majors"
              style={MMStyles.buttons}
              tabIndex="0"
              onClick={this.handleChange}
              value="0"
              className={`tab majors ${(this.state.value === 0 ||
                this.state.value === 5) &&
                "selected"}`}
              label="Majors"
            >
              Majors
            </button>
            <button
              id="minors"
              style={MMStyles.buttons}
              tabIndex="0"
              onClick={this.handleChange}
              value="1"
              className={`tab minors ${this.state.value === 1 && "selected"}`}
              label="Minors"
            >
              Minors
            </button>
            <button
              id="graduate"
              style={MMStyles.buttons}
              tabIndex="0"
              onClick={this.handleChange}
              value="2"
              className={`tab graduate ${this.state.value === 2 && "selected"}`}
              label="Graduate"
            >
              Graduate
            </button>
            <button
              id="acceleratedmasters"
              style={MMStyles.buttons}
              tabIndex="0"
              onClick={this.handleChange}
              value="3"
              className={`tab amp ${this.state.value === 3 && "selected"}`}
              label="Accelerated Degrees"
            >
              Accelerated Degrees
            </button>
            <button
              id="collegesandschools"
              style={MMStyles.buttons}
              tabIndex="0"
              onClick={this.handleChange}
              value="4"
              className={`tab colsc ${this.state.value === 4 && "selected"}`}
              label="Colleges and Schools"
            >
              Colleges and Schools
            </button>
          </div>
          <Row
            id="cards"
            bgc="#EAF5FB"
            padding="0px 0px"
            style={{ boxSizing: "border-box" }}
          >
            {this.state.value >= 0 ? this.renderView() : null}
          </Row>
        </div>
      );
    } else {
      return (
        <div id="mmgac">
          <div style={{ position: "relative" }}>
            <button
              id="majors"
              style={MMStyles.buttons}
              tabIndex="0"
              onClick={this.handleOpen}
              value="0"
              className={`tab majors ${(this.state.value === 0 ||
                this.state.value === 5) &&
                "selected"}`}
              label="Majors"
            >
              Majors
            </button>
            <div
              id="majorsList"
              className="cards"
              bgc="#EAF5FB"
              padding="0px 0px"
              style={{ ...this.state.styles.majors }}
            >
              <Majors data={this.state.majors} row={this.props} />
            </div>
          </div>
          <div style={{ position: "relative" }}>
            <button
              id="minors"
              style={MMStyles.buttons}
              tabIndex="0"
              onClick={this.handleOpen}
              value="1"
              className={`tab minors ${this.state.value === 1 && "selected"}`}
              label="Minors"
            >
              Minors
            </button>
            <div
              id="minorsList"
              className="cards"
              bgc="#EAF5FB"
              padding="0px 0px"
              style={this.state.styles.minors}
            >
              <Minors data={this.state.majors} row={this.props} />
            </div>
          </div>
          <div style={{ position: "relative" }}>
            <button
              id="graduate"
              style={MMStyles.buttons}
              tabIndex="0"
              onClick={this.handleOpen}
              value="2"
              className={`tab graduate ${this.state.value === 2 && "selected"}`}
              label="Graduate"
            >
              Graduate
            </button>
            <div
              id="graduateList"
              className="cards"
              bgc="#EAF5FB"
              padding="0px 0px"
              style={this.state.styles.graduate}
            >
              <Graduate data={this.state.majors} row={this.props} />
            </div>
          </div>
          <div style={{ position: "relative" }}>
            <button
              id="atm"
              style={MMStyles.buttons}
              tabIndex="0"
              onClick={this.handleOpen}
              value="3"
              className={`tab amp ${this.state.value === 3 && "selected"}`}
              label="Accelerated Degrees"
            >
              Accelerated Degrees
            </button>
            <div
              id="atmList"
              className="cards"
              bgc="#EAF5FB"
              padding="0px 0px"
              style={this.state.styles.atm}
            >
              <AccelleratedMasters data={this.state.majors} row={this.props} />
            </div>
          </div>
          <div style={{ position: "relative" }}>
            <button
              id="colleges"
              style={MMStyles.buttons}
              tabIndex="0"
              onClick={this.handleOpen}
              value="4"
              className={`tab colsc ${this.state.value === 4 && "selected"}`}
              label="Colleges and Schools"
            >
              Colleges and Schools
            </button>
            <div
              id="collegesList"
              className="cards"
              bgc="#EAF5FB"
              padding="0px 0px"
              style={this.state.styles.colleges}
            >
              <CollegesAndSchools data={this.state.majors} row={this.props} />
            </div>
          </div>
        </div>
      );
    }
  }
}

export default MajorsMinors;
